'use client';

import { Analytics } from '@/helpers/client/analytics';
import { AnimateOnScroll } from '@/helpers/client/animate-on-scroll';
import { CookieConsent } from '@/helpers/client/cookie-consent';
import { useStoryblok } from '@/helpers/client/storyblok';

/**
/**
 * Dynamically load on scroll animation
 */
export const Client = ({ draftModeEnabled, locale, storyTheme }) => {
  useStoryblok({ draftModeEnabled });

  return (
    <>
      <Analytics />

      <AnimateOnScroll />

      {!draftModeEnabled ? <CookieConsent locale={locale} /> : null}
    </>
  );
};
